import { cApi } from '@/config/env';
console.log(cApi, '....cApicApicApi')

export default {
    //首页-添加联盟信息
    addCoalitionAdd: { url: cApi + '/sp/web/addCoalitionAdd', method: 'post' },
    //首页三个榜单列表
    homeRankListV2: { url: cApi + '/noFilter/sp/web/homeRankListV2', method: 'post' },
    //公司列表
    companyRankList: { url: cApi + '/sp/miniApp/companyRankList', method: 'post' },
    //获取资源banner图
    bannerList: { url: cApi + '/sp/miniApp/bannerList', method: 'post' },
    // 热播榜单列表
    seriesRankList: { url: cApi + '/sp/miniApp/seriesRankList', method: 'post' },
    // 热播详情
    seriesRankDetail: { url: cApi + '/sp/web/seriesRankDetail', method: 'post' },
    // 热播列表
    seriesAwemeRankList: { url: cApi + '/sp/miniApp/seriesAwemeRankList', method: 'post' },
    // 热门素材榜单
    awemeRankList: { url: cApi + '/sp/miniApp/awemeRankList', method: 'post' },
    // 获取验证码
    sendSmsCode: { url: cApi + '/noFilter/sp/web/sendSmsCode', method: 'post' },
    // 登录
    webLogin: { url: cApi + '/noFilter/sp/web/login', method: 'post' },
    //  退出登录
    weblogOut: { url: cApi + '/sp/web/logOut', method: 'post' },
    // 上传图片
    upload: { url: cApi + '/noFilter/sp/web/file/7459999032912448787upload', method: 'post' },
    // web获取榜单50
    webSeriesRankList: { url: cApi + '/noFilter/sp/web/seriesRankList', method: 'post' },
    // 查询短剧详情
    seriesInfoGetDetail: { url: cApi + '/sp/miniApp/seriesInfo/getDetail', method: 'post' },
    // 获取投放数据统计
    getDeliveryData: { url: cApi + '/sp/miniApp/seriesInfo/getDeliveryData', method: 'post' },
    // 获取投放数据统计
    getVideo: { url: cApi + '/sp/miniApp/seriesInfo/getVideo', method: 'post' },
    //获取受众画像数据
    seriesInfoGetImageData: { url: cApi + '/sp/miniApp/seriesInfo/getImageData', method: 'post' },
    // 短剧排行列表
    newSeriesRankList: { url: cApi + '/sp/web/seriesRankList', method: 'post' },
    newSeriesList: { url: cApi + '/sp/web/seriesList', method: 'post' },
    // 短剧详情
    newGetSeriesDetail: { url: cApi + '/sp/web/getSeriesDetail', method: 'post' },
    // 获取素材列表排行
    getBySeriesName: { url: cApi + '/sp/web/materialList/getBySeriesName', method: 'post' },
    // 获取关联方
    getAffiliatesList: { url: cApi + '/sp/web/getAffiliatesList', method: 'post' },
    // 获取素材详情
    materialGetDetail: { url: cApi + '/sp/web/material/getDetail', method: 'post' },
    // 获取素材趋势
    getGrowingTrends: { url: cApi + '/sp/web/material/getGrowingTrends', method: 'post' },
    //获取素材列表
    materialRankList: { url: cApi + '/sp/web/findAwemeListV2', method: 'post' },
    //找素材对应的投放产品
    findAwemeAppNameListV2: { url: cApi + '/sp/web/findAwemeAppNameListV2', method: 'post' },
    // 获取找发行列表
    newCompanyRankList: { url: cApi + '/sp/web/companyRankList', method: 'post' },
    // 发行详情
    getCompanyDetail: { url: cApi + '/sp/web/getCompanyDetail', method: 'post' },
    // 发行详情关联短剧列表
    getCompanySeriesList: { url: cApi + '/sp/web/getCompanySeriesList', method: 'post' },
    // 发行详情投放数据
    getCompanyDeliveryData: { url: cApi + '/sp/web/getCompanyDeliveryData', method: 'post' },
    // 导出首页短剧榜单
    webSeriesRankListExcel: { url: cApi + '/sp/web/seriesRankList/export', method: 'post' },
    // 导出找热剧
    seriesListExcel: { url: cApi + '/sp/web/seriesList/export', method: 'post' },
    // 导出找发行
    companyRankListExcel: { url: cApi + '/sp/web/companyRankList/export', method: 'post' },
    // 导出找素材
    materialRankListExcel: { url: cApi + '/sp/web/materialRankList/export', method: 'post' },
    // 导出素材
    getBySeriesNameExcel: { url: cApi + '/sp/web/materialList/getBySeriesName/export', method: 'post' },
    // 根据字典类型查询所有的值
    getDictDataByType: { url: cApi + '/sp/web/getDictDataByType', method: 'post' },
    // 获取关联方
    getAffiliatesList: { url: cApi + '/sp/web/getAffiliatesList', method: 'post' },
    // 上传图片
    uploadImage: { url: cApi + '/sp/web/uploadImage', method: 'post' },
    // 添加备案信息
    add: { url: cApi + '/sp/web/record/add', method: 'post' },
    //修改备案信息
    edit: { url: cApi + '/sp/web/record/edit', method: 'post' },
    // 获取备案列表
    getList: { url: cApi + '/sp/web/record/getList', method: 'post' },
    // 获取备案详情
    getDetail: { url: cApi + '/sp/web/record/getDetail', method: 'post' },
    // 提交备案
    submit: { url: cApi + '/sp/web/record/submit', method: 'post' },
    // 删除备案
    del: { url: cApi + '/sp/web/record/del', method: 'post' },
    // 获取用户信息
    getUserInfo: { url: cApi + '/sp/web/getUserInfo', method: 'get' },
    // 用户修改密码
    updatePasswd: { url: cApi + '/sp/web/user/updatePasswd', method: 'post' },
    // 用户密码登录
    passwdLogin: { url: cApi + '/noFilter/sp/web/passwdLogin', method: 'post' },
    // 用户修改图像
    updateAvatar: { url: cApi + '/sp/web/user/updateAvatar', method: 'post' },
    //获取ads素材
    getAdsAwemeList: { url: cApi + '/sp/web/aweme/getAdsAwemeList', method: 'post' },
    // 获取ads详情
    getAdsAwemeDetail: { url: cApi + '/sp/web/material/getDetail', method: 'post' },
    //获取小程序登录二维码
    getLoginQrcode: { url: cApi + '/noFilter/sp/web/getLoginQrcode', method: 'post' },
    //轮训获取二维码登录状态
    getLoginQrcodeStatus: { url: cApi + '/noFilter/sp/web/getLoginQrcodeStatus', method: 'post' },
    //获取达人素材对应的产品列表
    getAwemeAppNameList: { url: cApi + '/sp/web/aweme/getAwemeAppNameList', method: 'post' },
    // mcn榜单列表
    mcnRankListV2: { url: cApi + '/sp/web/mcnRankListV2', method: 'post' },
    //端原生
    playRankListV2: { url: cApi + '/sp/web/playRankListV2', method: 'post' },
    // 端原生小时列表
    playRankListHourV2: { url: cApi + '/sp/web/playRankListHourV2', method: 'post' },
    //快手列表
    ksRankListV2: { url: cApi + '/sp/web/ksRankListV2', method: 'post' },
    //短剧详情-查询用户画像
    getImageData: { url: cApi + '/sp/web/seriesInfo/getImageData', method: 'post' },
    //短剧详情-上榜记录
    getSeriesRankList: { url: cApi + '/sp/web/seriesInfo/getSeriesRankList', method: 'post' },
    //短剧详情-查询投放数据统计
    getDeliveryData: { url: cApi + '/sp/web/seriesInfo/getDeliveryData', method: 'post' },
    //短剧详情-获取端原生信息
    getSeriesPlayDetail: { url: cApi + '/sp/web/seriesInfo/getSeriesPlayDetail', method: 'post' },
    //短剧详情-基础信息
    getDetailV2: { url: cApi + '/sp/web/seriesInfo/getDetailV2', method: 'post' },
    //短剧详情-演员信息信息提报
    addActorData: { url: cApi + '/sp/web/seriesInfo/addActorData', method: 'post' },
    //短剧详情-关联方、制作方、版权方提报
    addReportData: { url: cApi + '/sp/web/seriesInfo/addReportData', method: 'post' },
    //找公司
    findCompany: { url: cApi + '/sp/web/v2/findCompany', method: 'post' },
    //找公司详情
    companyDetail: { url: cApi + '/sp/web/v2/companyDetail', method: 'post' },
    //获取PC端会员产品列表
    getProductList: { url: cApi + '/sp/web/getProductList', method: 'post' },
    //PC会员购买-获取微信支付二维码
    genPcWeixinPayOrder: { url: cApi + '/sp/web/genPcWeixinPayOrder', method: 'post' },
    //PC会员购买-获取微信支付状态
    getPcWeixinPayOrderStatus: { url: cApi + '/sp/web/getPcWeixinPayOrderStatus', method: 'post' },
    // PC会员-CDK码兑换会员天数
    cdkExchangeVip: { url: cApi + '/sp/web/cdkExchangeVip', method: 'post' },
    // 个人中心-获取会员日志记录
    getUserVipLogs: { url: cApi + '/sp/web/getUserVipLogs', method: 'post' },
    // 更新用户头像和昵称
    updateUserInfo: { url: cApi + '/sp/web/updateUserInfo', method: 'post' },
    // 个人中心-我关联的短剧（我参演的短剧）
    getActorAssociatedSeriesInfo: { url: cApi + '/sp/web/getActorAssociatedSeriesInfo', method: 'post' },
    // 个人中心短剧收藏
    seriesInfocollect: { url: cApi + '/sp/web/seriesInfo/collect', method: 'post' },
    // 个人中心-取消短剧收藏
    seriesCollectcancel: { url: cApi + '/sp/web/seriesCollect/cancel', method: 'post' },
    // 个人中心-获取短剧收藏列表
    getSeriesCollectList: { url: cApi + '/sp/web/getSeriesCollectList', method: 'post' },
    // 个人中心-获取素材收藏列表
    getMaterialCollectList: { url: cApi + '/sp/web/getMaterialCollectList', method: 'post' },
    // 个人中心-我关注的演员列表
    actorGzList: { url: cApi + '/sp/web/actorGzList', method: 'post' },
    // 个人中心-素材收藏
    awemecollect: { url: cApi + '/sp/web/aweme/collect', method: 'post' },
    // 个人中心-取消素材收藏
    awemeCollectcancel: { url: cApi + '/sp/web/awemeCollect/cancel', method: 'post' },
    // 个人中心-素材收藏
    getMaterialCollectList: { url: cApi + '/sp/web/getMaterialCollectList', method: 'post' },
    //品牌榜列表
    brandRankList: { url: cApi + '/sp/web/brandRankList', method: 'post' },
    //漫剧标签
    manjuTagList: { url: cApi + '/sp/web/manjuTagList', method: 'post' },
    //漫剧列表
    manjuInfoList: { url: cApi + '/sp/web/manjuInfoList', method: 'post' },
    //演员榜
    actorRankList: { url: cApi + '/sp/web/actorRankList', method: 'post' },
    //演员详情
    actorDetail: { url: cApi + '/sp/web/actorDetail', method: 'post' },
    //演员相册
    albumList: { url: cApi + '/sp/web/actor/albumList', method: 'post' },

};


// WEBPACK FOOTER //
// ./src/api/list.js